import BingMaps from "ol/source/BingMaps";

function bingAerialLabels() {
  return new BingMaps({
    key: "Aip1YMXgbcNLtTfnbtILxcTmhf_523ldUGjRBIToIlUHc-4cc4bm-tWqQqp32NTf",
    imagerySet: "AerialWithLabelsOnDemand",
  });
}

export default bingAerialLabels;
